module.exports = __webpack_public_path__ + "img/电子报告图@2x.ae7925b0.png";